export const styles = {
  wrapper: {
    width: 150,
    display: 'flex',
    justifyContent: 'center',
    padding: 4,
    borderRadius: 8,
  },
  activeWrapper: {
    color: '#00840D',
    backgroundColor: '#E0F5E2',
  },
  expiredWrapper: {
    color: '#011533',
    backgroundColor: '#E4E4EA',
  },
  pendingWrapper: {
    color: '#323121',
    backgroundColor: '#FFFCB0',
  },
  notSignedWrapper: {
    color: '#D72B4F',
    backgroundColor: '#FFD2DB',
  },
  pendingExtentionsWrapper: {
    color: '#242019',
    backgroundColor: '#FFE4B0',
  },
  concludedWrapper: {
    color: '#9747FF',
    backgroundColor: '#9747FF1F',
    opacity: 0.2,
  },
}
